import { useEffect, useState } from 'react';

export const ProgressHeader = () => {
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            // Calculate how far down the page the user has scrolled
            const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
            const progress = (window.scrollY / totalHeight) * 100;
            setScrollProgress(progress);
        };

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Clean up
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="fixed top-0 left-0 right-0 z-5000">
            <div className="h-1 w-full bg-black">
                <div
                    className="h-full bg-gradient-to-r from-pink-600/25 via-purple-600 to-pink-600/25 transition-all duration-300 ease-out"
                    style={{
                        width: '100%',
                        transform: `scaleX(${scrollProgress / 100})`,
                        transformOrigin: 'center'
                    }}
                />
            </div>
        </div>
    );
};